import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import App from './App'
import { bootGtm } from './utils/gtmBoot'
import './i18n'
import './styles/enterprise.css'
import './styles/portal.css'
import './styles/global.css'

// Google Tag Manager (Consent Mode v2 + container) — loads only on the customer
// host when a container id is configured; fail-safe, never blocks rendering.
bootGtm()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
